export  const resources = {
    // APPLICATION_URL:  `https://app.adhikrit.com:8443/saispurthi-website-backend/api/v1/`,
    // AUTHORIZE_URL:  `https://app.adhikrit.com:8443/saispurthi-website-backend/api/auth/`,
   APPLICATION_URL:  `http://103.175.183.120:8080/saispurthi-website-backend/api/v1/`,
    AUTHORIZE_URL:  `http://103.175.183.120:8080/saispurthi-website-backend/api/auth/`
}